(function () {

  var TIERS = [
    { buy: 2,  free: 2  },
    { buy: 4,  free: 5  },
    { buy: 6,  free: 15 },
    { buy: 10, free: 35 },
  ];

  var LABELS = ['Starter', 'Popular', 'Best Value', 'Room Makeover'];

  /* ── Styles — product page only ── */
  var st = document.createElement('style');
  st.textContent =
    '#bxgy-tiers{margin:16px 0;}' +
    '#bxgy-tiers .bxgy-heading{font-size:13px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;color:#111;margin-bottom:10px;}' +
    '#bxgy-tiers .bxgy-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px;}' +
    '#bxgy-tiers .bxgy-card{border:1.5px solid #e0e0e0;border-radius:10px;padding:10px 12px;background:#fff;}' +
    '#bxgy-tiers .bxgy-card.best{border-color:#e8460a;}' +
    '#bxgy-tiers .bxgy-badge{font-size:9px;font-weight:700;text-transform:uppercase;background:#e8460a;color:#fff;border-radius:4px;padding:2px 6px;display:inline-block;margin-bottom:4px;}' +
    '#bxgy-tiers .bxgy-badge.grey{background:#555;}' +
    '#bxgy-tiers .bxgy-title{font-size:13px;font-weight:700;color:#111;line-height:1.3;}' +
    '#bxgy-tiers .bxgy-sub{font-size:11px;color:#666;margin-top:2px;}' +
    '#bxgy-tiers .bxgy-auto{font-size:11px;color:#e8460a;font-weight:600;margin-top:4px;}';
  document.head.appendChild(st);

  /* ── Product page tier cards ── */
  function initProductPage() {
    var meta = document.querySelector('meta[name="bxgy-enabled"]');
    if (!meta || meta.content !== 'true') return;

    var pid = meta.dataset.productId;
    if (pid) {
      try {
        var ids = JSON.parse(sessionStorage.getItem('bxgy_pids') || '[]');
        if (ids.indexOf(pid) === -1) { ids.push(pid); sessionStorage.setItem('bxgy_pids', JSON.stringify(ids)); }
      } catch(e) {}
    }

    if (document.getElementById('bxgy-tiers')) return;
    var c = document.createElement('div'); c.id = 'bxgy-tiers';
    var cards = TIERS.map(function(t, i) {
      var best = t.buy === 6;
      return '<div class="bxgy-card' + (best ? ' best' : '') + '">' +
        '<span class="bxgy-badge' + (best ? '' : ' grey') + '">' + LABELS[i] + '</span>' +
        '<div class="bxgy-title">Buy ' + t.buy + ' Get ' + t.free + ' Free</div>' +
        '<div class="bxgy-sub">' + (t.buy + t.free) + ' posters, pay for ' + t.buy + '</div>' +
        '<div class="bxgy-auto">✓ Auto-applies at checkout</div>' +
        '</div>';
    }).join('');
    c.innerHTML = '<div class="bxgy-heading">🎁 Bulk Free Offers — Per Size</div><div class="bxgy-grid">' + cards + '</div>';
    var anchor = document.querySelector('.product-form-buttons') || document.querySelector('form[action*="/cart"]');
    if (anchor) anchor.parentNode.insertBefore(c, anchor);
  }

  /* ── Init ── */
  function init() {
    if (document.querySelector('meta[name="bxgy-enabled"]')) initProductPage();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();
